<div class="loader-container">
  <div class="loader"></div>
</div>